// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperSelector-cls1_QZh","cls2":"PaperSelector-cls2_aUt PaperSelector-cls1_QZh"};